module.exports = __webpack_public_path__ + "static/media/4.57362317.jpg";